<template>
  <div>
    <el-tooltip class="item" effect="dark" content="全屏" placement="bottom">
      <i class="el-icon-full-screen" @click="click" />
    </el-tooltip>
  </div>
</template>
<script>
import screenfull from "screenfull";
export default {
  name: "Screenfull",
  data() {
    return {};
  },
  methods: {
    click() {
      if (!screenfull.isEnabled) {
        this.$message({
          message: "您的浏览器不支持全屏",
          type: "warning"
        });
        return false;
      }
      screenfull.toggle();
      //   this.$message({
      //       message:'OK',
      //       type:'success'
      //   })
    }
  }
};
</script>
<style lang="less" scoped></style>
